import { useSearchParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { getCustomer } from 'queries';
import { JsonDataItem } from 'types';
import { parseErrors, Toast } from 'helpers';

export const useBookingStartParams = () => {
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get('customer_id');

  const { data: customer, isLoading: isCustomerLoading } = useQuery(['get-customer', customerId], getCustomer, {
    enabled: !!customerId,
    onError: (error: JsonDataItem) => {
      Toast.show({
        description: parseErrors(error).join(', '),
        type: Toast.Type.Error,
      });
    },
  });

  return {
    customer,
    isCustomerLoading,
  };
};
